import script from "./contactus-component.vue?vue&type=script&setup=true&lang=js"
export * from "./contactus-component.vue?vue&type=script&setup=true&lang=js"

import "./contactus-component.vue?vue&type=style&index=0&id=2b1b6aee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b1b6aee"]])

export default __exports__